// extracted by mini-css-extract-plugin
export var Footer = "Footer-module--Footer--1-t5n";